import { __assign, __rest } from "tslib";
import React, { useState, useRef, useCallback } from 'react';
import cn from 'classnames';
import { useBiLogger } from '@wix/da-bi/pkg/hooks/useBiLogger';
import { BiData, BiContextProvidedValue, } from '@wix/da-bi/pkg/events';
import { useThrottle } from '@wix/da-hooks/pkg/useThrottle';
import { useDeviationViewContext } from '../../../Context';
import Sticky from '../../../Sticky';
import CommentBox from '../CommentBox';
import { StickyCommentBoxContext } from './context';
import s from './StickyCommentBox.scss';
var stickyPadding = parseInt(s['sticky-padding']);
var StickyCommentBox = function (_a) {
    var _b = _a.commentBoxPreset, CommentBoxPreset = _b === void 0 ? CommentBox : _b, className = _a.className, rest = __rest(_a, ["commentBoxPreset", "className"]);
    var _c = useState(false), shouldStickIfAble = _c[0], setShouldStickIfAble = _c[1];
    var isTheater = useDeviationViewContext().isTheater;
    var commentBoxRef = useRef(null);
    var logEvent = useBiLogger();
    var checkIfStuck = useCallback(function (rect) {
        var _a;
        if (!shouldStickIfAble) {
            return false;
        }
        var height = ((_a = commentBoxRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight) || rect.height;
        // eslint-disable-next-line
        return rect.top + height + stickyPadding > window.innerHeight;
    }, [shouldStickIfAble]);
    var handleBlur = function (isStuck) { return function (ev) {
        var commentBoxEl = commentBoxRef.current;
        if (isStuck && commentBoxEl && commentBoxEl.contains(ev.relatedTarget)) {
            // Don't unstick if the user clicks on something in the comment box element.
            return;
        }
        setShouldStickIfAble(false);
    }; };
    var handleStuckChange = useThrottle(function (isStuck) {
        return logEvent(BiData({
            evid: 179,
            itemid: BiContextProvidedValue,
            typeid: BiContextProvidedValue,
            is_comment_thread: BiContextProvidedValue,
            is_sticky: isStuck ? 1 : 0,
        }));
    }, [logEvent], 1000);
    return (React.createElement(Sticky, { className: cn(s['stuck'], isTheater && s['theater-view']), stickTo: 'bottom', customCheckIfStuck: checkIfStuck, onStuckChange: handleStuckChange }, function (isStuck) { return (React.createElement(StickyCommentBoxContext.Provider, { value: isStuck },
        React.createElement(CommentBoxPreset, __assign({ className: cn(className, isStuck && s['comment-box']), onFocus: function () { return setShouldStickIfAble(true); }, onBlur: handleBlur(isStuck), onPost: function () { return setShouldStickIfAble(false); }, onClose: function () { return setShouldStickIfAble(false); }, ref: commentBoxRef }, rest)))); }));
};
export default StickyCommentBox;
//# sourceMappingURL=StickyCommentBox.js.map